import Image from 'next/image';
import styles from './WishlistIcon.module.css';
import { useGlobalContext } from '@/lib/context';

type props = {
    productId: number;
    WishlistType: string;
    customStyles?: Object
}

export function WishlistIcon({ productId, WishlistType, customStyles }: props) {
    const { props: { addToWishlist, wishlistItems } } = useGlobalContext();
    const isWishlistItem = wishlistItems && wishlistItems.find(item => item.prodId === productId && item.type === WishlistType);
    return (
        <div className={styles.addToWishList} style={customStyles} onClick={() => addToWishlist(productId, WishlistType)}>
            <Image
                src={`${process.env.SITE_URL}/assets/images/${(isWishlistItem) ? 'heart-red-fill.svg' : 'heart-new.svg'}`}
                className="img-responsive"
                alt="Add to Wishlist"
                width={16}
                height={14}
            />
        </div>
    );
}
